// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT_PROFILE: `Perfil da conta`,
    ADA_TOGGLE_ON: `Toque para ativar a altura de tela reduzida`,
    ADA_TOGGLE_OFF: `Toque para desativar a altura de tela reduzida`,
    ADD: `Adicionar`,
    ADD_DONATION: `Adicionar doação`,
    ADD_FUNDS: `Adicionar fundos`,
    ADD_TIP: `Adicionar gorjeta`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `Adicionar ao pedido`,
    ADD_NEW: `Adicionar novo`,
    ADDED: `Adicionado`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `Adicionado ao pedido`,
    ADDON_TEXTFIELD_PLACEHOLDER: `Digite sua escolha.`,
    ADDRESS_CITY: `Cidade`,
    ADDRESS_LINE_1: `Endereço`,
    ADDRESS_LINE_2: `Apto, Andar, Suite, Edifício, Empresa (Opcional)`,
    ADDRESS_POSTAL_CODE: `CEP`,
    ALCOHOL_VERIFICATION: `Verificação de álcool`,
    ALSO_CONSIDER: `Você também pode gostar...`,
    APPLIED_STORED_VALUE_CARDS: `Vales-presente`,
    ASAP: `O mais rápido possível`,
    AT_LEAST_X: `pelo menos {{$1: number}}`,
    BACK: `Voltar`,
    BACK_TO_MENU: `Voltar ao menu`,
    BACK_TO_MENU_FROM_LOYALTY: `Voltar ao menu`,
    BACK_TO_CART: `Voltar ao carrinho`,
    BACK_TO_PAYMENT_OPTIONS: `Voltar às opções de pagamento`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `Voltar às opções de pagamento`,
    BAD_ACCESS_CODE: `Código de acesso incorreto`,
    BALANCE: `Saldo`,
    BAG_OPT_IN_PROMPT: `Gostaria de adicionar uma sacola para o seu pedido?`,
    BAG_OPT_IN_TITLE: `Adicionar sacola?`,
    BAG_OPT_IN: `Sim, quero uma sacola`,
    BAG_OPT_OUT: `Não, obrigado`,
    BLOCKED_WORD_WARNING: `Por favor, remova as palavras bloqueadas`,
    CALORIES: `Calorias`,
    CANCEL: `Cancelar`,
    CANCEL_CHECKOUT: `Cancelar`,
    CASH: `Caixa`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `Cartão cadastrado`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `Sem contato`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `Inserido manualmente`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `Fornecido externamente`,
    CARD_ENTRY_SCAN: `Escanear`,
    CARD_ENTRY_SWIPE: `Passar o cartão`,
    CARD_ENTRY_UNKNOWN: `Desconhecido`,
    CARD_EXPIRED: `Cartão vencido`,
    CARD_EXPIRING: `Seu cartão vence em breve`,
    CART: `Carrinho`,
    CART_LABEL: `Ir ao carrinho com {{$1: number}} itens por {{$2: price}}`,
    CART_TITLE: ``,
    CHANGE_ITEM: `Alterar item`,
    CHANGE_PASSWORD: `Alterar senha`,
    CHANGE_PASSWORD_SUCCESS: `Sua senha foi atualizada.`,
    CHARS_LEFT: `{{$1: number}} caracteres restantes`,
    CHECK_AMOUNT: `Verificando valor...`,
    CHECKOUT: `Finalizar pedido`,
    CHECKOUT_STEP_CART: `Carrinho`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `Pagamento`,
    CHECKOUT_STEP_PAYING: `Pagando`,
    CHECKOUT_STEP_DONE: `Concluído`,
    CHECKOUT_WITH_FORCED_MENU: `Não é possível fechar pedidos durante a Visualização do Menu. Só é possível fechar o pedido no menu "Exibição atual".`,
    CHOOSE_OPTION: `Escolha uma opção`,
    CHOOSE_TIME_SLOT: `Por favor, escolha um horário:`,
    CLEAR_ALL: `Limpar tudo`,
    CLEARING_SESSION: `Preparando o quiosque para o próximo cliente...`,
    CLOSE: `Fechar`,
    CLOSED_SCREEN_MESSAGE: `Desculpe, estamos fechados ou não aceitamos pedidos pelo celular.`,
    CONFIRM: `Confirmar`,
    CONFIRM_ADDRESS: `Confirmar endereço`,
    CONFIRM_DISCARD: `Descartar item?`,
    CONFIRM_DISCARD_CHANGES: `Tem certeza de que deseja descartar as alterações?`,
    CONFIRM_YOUR_ITEM: `Confirme seu item`,
    CONFIRM_QUIT: `Tem certeza de que deseja sair?`,
    CONFIRM_REFUND_AMOUNT: `Tem certeza de que deseja reembolsar {{$1: dollar amount}} desta transação?`,
    CONFIRMING_YOUR_CARD: `Confirmando seu cartão...`,
    CONTINUE: `Continuar`,
    CONTINUE_AS_GUEST: `Continuar como convidado`,
    COULD_WE_INTEREST: `Que tal isso...`,
    COMP_CARD: `Cartão de cortesia`,
    COMP_CARD_SCAN: `Escanear cartão de cortesia`,
    COMP_CARD_SCAN_FAILED_TITLE: `Falha ao escanear cartão de cortesia`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `Ocorreu um erro ao escanear o cartão de cortesia. Por favor, tente novamente.`,
    COMP_CARD_APPLYING_TITLE: `Aplicando cartão de cortesia`,
    COMP_CARD_APPLYING_ERROR_TITLE: `Erro ao aplicar cartão de cortesia`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `Ocorreu um erro ao aplicar o cartão de cortesia. Por favor, tente novamente.`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Por favor, insira um número de cartão de cortesia`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `Por favor, insira um número de cartão de cortesia válido`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Por favor, insira um número de cartão de cortesia válido`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `Por favor, insira um PIN de cartão de cortesia`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `Por favor, insira um PIN de cartão de cortesia válido`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `Por favor, insira um PIN de cartão de cortesia válido`,
    COMP_CARD_ENTERING_NUMBER_HINT: `Insira o número do cartão de cortesia. Os números podem ter {{$1: number}} dígitos.`,
    COMP_CARD_ENTERING_PIN_HINT: `Insira o PIN do cartão de cortesia. Os números podem ter {{$1: length}} dígitos.`,
    COMP_CARD_ERROR_REMOVING: `Ocorreu um erro ao remover o cartão de cortesia. Por favor, tente novamente.`,
    'bottom-bar.storm-toggle.on': `Toque para ativar a navegação Storm`,
    'bottom-bar.storm-toggle.off': `Toque para desativar a navegação Storm`,
    'campus-card.label': `Cartão universitário`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `Toque para pagar com cartão universitário`,
    'campus-card.scan': `Escanear cartão universitário`,
    'campus-card.scan-failed.title': `Falha ao escanear cartão universitário`,
    'campus-card.scan-failed.message': `Ocorreu um erro ao escanear o cartão universitário. Por favor, tente novamente.`,
    'campus-card.enter-number': `Inserir número do cartão universitário`,
    'campus-card.enter-pin': `Inserir PIN do cartão universitário`,
    'campus-card.applying.title': `Aplicando cartão universitário`,
    'campus-card.applying.error.title': `Erro ao aplicar cartão universitário`,
    'campus-card.applying.error.message': `Ocorreu um erro ao aplicar o cartão universitário. Por favor, tente novamente.`,
    'campus-card.entering-number.error.required': `Por favor, insira um número de cartão universitário`,
    'campus-card.entering-number.error.invalid': `Por favor, insira um número de cartão universitário válido`,
    'campus-card.entering-number.error.length': `Por favor, insira um número de cartão universitário válido`,
    'campus-card.entering-number.hint': `Insira o número do cartão universitário. Os números podem ter {{$1: number}} dígitos.`,
    'campus-card.entering-pin.error.required': `Por favor, insira um PIN de cartão universitário`,
    'campus-card.entering-pin.error.invalid': `Por favor, insira um PIN de cartão universitário válido`,
    'campus-card.entering-pin.error.length': `Por favor, insira um PIN de cartão universitário válido`,
    'campus-card.entering-pin.hint': `Insira o PIN do cartão universitário. Os números podem ter {{$1: length}} dígitos.`,
    'campus-card.error-removing': `Ocorreu um erro ao remover o cartão universitário. Por favor, tente novamente.`,
    'campus-card.no-balance.title': `Sem saldo disponível`,
    'campus-card.no-balance.message': `Este cartão universitário não tem saldo disponível.`,
    'campus-card.add-another': `Adicionar outro`,
    'campus-card.remove': `Remover cartão universitário`,
    'campus-card.select-account.title': `Selecionar conta`,
    'campus-card.select-account.loading': `Carregando contas...`,
    'campus-card.select-account.error.title': `Não foi possível carregar as contas`,
    'campus-card.select-account.error.message': `Não foi possível carregar suas contas. Por favor, tente novamente.`,
    'campus-card.select-account.column.account': `Conta`,
    'campus-card.select-account.column.balance': `Saldo atual`,
    'campus-card.select-account.error.toast-title': `Erro`,
    'campus-card.select-account.error.toast-message': `Falha na validação. Por favor, tente novamente.`,
    'campus-card.swipe': `Passe o cartão universitário para pagar`,
    COUPON: `Cupom`,
    COUPON_ALREADY_USED: `O código do cupom já foi usado.`,
    COUPON_MIN_SPEND_NOT_MET: `O código do cupom inserido não atende ao requisito de gasto mínimo.`,
    COUPON_NOT_FOUND: `Código do cupom não encontrado.`,
    COUPON_NOT_ACCEPTED: `O código do cupom inserido não foi aceito.`,
    COUPON_APPLYING: `Aplicando cupom`,
    COUPON_APPLYING_ERROR_TITLE: `Erro ao aplicar cupom`,
    COUPON_APPLYING_ERROR_MESSAGE: `Ocorreu um erro ao aplicar o cupom. Por favor, tente novamente.`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `O código do cupom inserido não atende aos requisitos do pedido.`,
    COUPON_SCANNING_ERROR_TITLE: `Erro ao escanear cupom`,
    COUPON_SCANNING_ERROR_MESSAGE: `Ocorreu um erro ao escanear o cupom. Por favor, tente novamente.`,
    COUPON_ENTERING_ERROR_LENGTH: `Por favor, insira um código de cupom.`,
    COUPON_ENTERING_ERROR_INVALID: `Por favor, insira um código de cupom válido.`,
    COUPON_ERROR_REMOVING: `Ocorreu um erro ao remover o cupom. Por favor, tente novamente. Se o problema persistir, contate um membro da equipe.`,
    CREATE_A_NEW_ACCOUNT: `Criar nova conta`,
    CREATE_ACCOUNT: `Criar conta`,
    CREATE_ACCOUNT_TERMS_LINE: `Ao criar uma conta, você concorda com os`,
    CREDIT_CARD: `Cartão de crédito`,
    CREDIT_CARD_NUMBER: `Número do cartão`,
    CURBSIDE: `Retirada na calçada`,
    CURRENT_PASSWORD: `Senha atual`,
    CUSTOM_TIP: `Personalizado`,
    CUSTOM_TIP_INVALID: `Por favor, insira um valor de gorjeta válido.`,
    CUSTOM_TIP_HINT: `Insira o valor da gorjeta. Máximo: {{$1: number}}`,
    CUSTOM_DONATION: `Doação personalizada`,
    CUSTOMER_CARDS: `Usar cartão cadastrado`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `Entrar`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `Minha conta`,
    CUSTOMIZE: `Personalizar`,
    DEBIT: `Débito`,
    DEBIT_CREDIT_CARD: `Cartão débito/crédito`,
    DEMO_PAY: `Demo: Pagar`,
    DELIVERY: `Entrega`,
    DELIVERY_ADDRESS: `Endereço de entrega`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `Remover {{$1: mod name}}`,
    DINE_IN: `Comer no local`,
    DISCLAIMER_EMAIL: `O uso do endereço de e-mail está sujeito aos termos de serviço.`,
    DISCLAIMER_PHONE: `O uso do número de telefone está sujeito aos termos de serviço.`,
    DISCLAIMER_PHONE_LINK: `TERMOS DE SERVIÇO:`,
    DISCLAIMER_PHONE_DESCRIPTION: `PARA USO DO NÚMERO DE TELEFONE`,
    DISCLAIMER_NAME: `Seu nome será usado para confirmar seu pedido e facilitar a retirada na área designada.`,
    DISCOUNTS: `Descontos`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `Os descontos serão aplicados no checkout`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `O desconto será aplicado no checkout`,
    DONATION: `Doação`,
    DONATION_APPLYING: `Processando doação...`,
    DONATION_APPLY_ERROR_TITLE: `Erro ao aplicar doação`,
    DONATION_APPLY_ERROR_MESSAGE: `Ocorreu um erro ao processar sua doação. Por favor, tente novamente.`,
    DONATION_FAILED: `A doação falhou. Por favor, tente novamente.`,
    DONATION_ROUND_UP_TITLE: `Gostaria de arredondar o total?`,
    DONATION_ROUND_UP_TO: `Arredondar para {{$1: amount}}`,
    DONATION_ROUND_UP_SUBTITLE: `Gostaria de arredondar o total para o próximo real?`,
    DONATION_ROUND_UP_ACCEPT: `Sim, arredondar`,
    DONATION_ROUND_UP_REJECT: `Não, obrigado`,
    DONATION_REMOVE: `Remover doação`,
    DONE: `Concluído`,
    DONT_INCLUDE_UTENSILS: `Não incluir talheres`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `Reembolso EBT`,
    EBT_CHOICE_DIALOG_TITLE: `Qual método EBT deseja usar?`,
    EBT_CHOICE_CASH_BENEFIT: `Benefício em dinheiro`,
    EBT_CHOICE_FOOD_STAMPS: `Vale-alimentação`,
    EBT_CARD_SUBTITLE: `Passe seu cartão EBT na maquininha`,
    EDIT: `Editar`,
    EDIT_ORDER: `Editar pedido`,
    EDIT_TIP: `Editar gorjeta`,
    SAVE_ORDER: `Salvar pedido`,
    EMAIL_ADDRESS: `Endereço de e-mail`,
    EMAIL_RECEIPT: `Recibo por e-mail`,
    EMAIL_REQUIRED_FOR_RECEIPT: `É necessário um e-mail para o recibo.`,
    EMAIL_RECEIPT_SEND_FAILED: `Não foi possível enviar o recibo. Por favor, tente novamente.`,
    EMAIL_RECEIPT_SEND_SUCCESS: `Recibo enviado com sucesso.`,
    ENTER_ACCESS_CODE: `Insira o código de acesso:`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `Insira seu e-mail`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `Não consegue escanear? Insira o número do cartão.`,
    ENTER_PHONE_CONSENT: `Concordo em receber materiais de marketing por SMS.`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `Insira seu número de telefone`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `Olá {{$1 guest name}}, por favor insira seu número de telefone`,
    ENTER_PHONE_LOYALTY: `Insira seu número de celular`,
    ENTER_PHONE_RECEIPT: `Insira seu número de celular para receber o recibo`,
    ENTER_PHONE_TEXT_WHEN_READY: `Insira seu número de telefone para receber uma mensagem quando seu pedido estiver pronto!`,
    ENTER_VEHICLE_DESCRIPTION: `Por favor, insira os detalhes do seu veículo para que possamos trazer seu pedido:`,
    ENTER_YOUR_COUPON_CODE: `Insira seu código de cupom`,
    ENTER_YOUR_COMP_CARD_NUMBER: `Insira o número do cartão de cortesia`,
    ENTER_YOUR_COMP_CARD_PIN: `Insira o PIN do cartão de cortesia`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `Insira o número do vale-presente`,
    ENTER_YOUR_GIFT_CARD_PIN: `Insira o PIN do vale-presente`,
    ENTER_YOUR_EMAIL: `Insira seu e-mail:`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `E-mail inválido. Por favor, tente novamente.`,
    ENTER_YOUR_FIRST_NAME: `Insira seu nome:`,
    ENTER_YOUR_LAST_NAME: `Insira a inicial do seu sobrenome:`,
    ENTER_YOUR_NAME: `Insira seu nome:`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `Nome inválido. Por favor, tente novamente.`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `Por favor, insira um nome.`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `Apenas uma letra é permitida. Por favor, tente novamente.`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `O nome deve conter apenas letras. Por favor, tente novamente.`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `O nome contém palavras inadequadas. Por favor, tente novamente.`,
    ERROR: `Ops!`,
    ERROR_ADDING_ITEM: `Ocorreu um erro ao adicionar o item ao carrinho. Por favor, tente novamente. Se o problema persistir, peça ajuda ao membro da equipe mais próximo.`,
    ERROR_EDITING_ITEM: `Ocorreu um erro ao editar o item no carrinho. Por favor, tente novamente. Se o problema persistir, peça ajuda ao membro da equipe mais próximo.`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `O valor excede o saldo do cartão.`,
    ERROR_CARD_CONFIRMATION: `Desculpe! Não foi possível confirmar o cartão. Por favor, tente novamente.`,
    ERROR_CARD_DECLINED: `Não foi possível cobrar o cartão indicado. Por favor, tente novamente.`,
    ERROR_CARD_INACTIVE: `Desculpe, este cartão estudantil não está ativo.`,
    ERROR_CARD_NOT_FOUND: `Desculpe! Não foi possível encontrar este cartão. Por favor, tente novamente.`,
    ERROR_CARD_NUMBER_LENGTH: `O número do cartão não tem o comprimento correto.`,
    ERROR_CARD_RESTRICTED_TIME: `Desculpe, este cartão não pode ser usado no momento.`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `Desculpe, {{$1: cardScheme}} não é aceito aqui. Poderia tentar outro cartão?`,
    ERROR_COUPON_CONFIRMATION: `Desculpe! Não foi possível usar o código do cupom. Por favor, tente novamente.`,
    ERROR_INVALID_EMAIL: `Endereço de e-mail inválido`,
    ERROR_INVALID_LOGIN_CREDS: `Nome de usuário ou senha inválidos`,
    ERROR_INVALID_NAME: `Por favor, insira um nome válido`,
    ERROR_INVALID_PHONE_NUMBER: `Por favor, insira um número de telefone válido`,
    ERROR_INVALID_ROOM_NUMBER: `Por favor, insira um número de quarto válido`,
    ERROR_INVALID_TABLE_NUMBER: `Por favor, insira um número de mesa válido`,
    ERROR_INVALID_VERIFICATION_CODE: `Código de verificação inválido`,
    ERROR_KIOSK_CARD_DECLINED: `Algo deu errado. Seu cartão não foi cobrado. Por favor, tente novamente.`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `Não foi possível ler o cartão. Por favor, tente novamente.`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `O quiosque não conseguiu encontrar o dispositivo de pagamento. Seu cartão não foi cobrado. Por favor, contate um membro da equipe.`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `O dispositivo de pagamento parece estar offline. Seu cartão não foi cobrado. Por favor, contate um membro da equipe.`,
    ERROR_ORDER_OPERATION: `Desculpe, não foi possível processar seu pedido. Por favor, tente novamente.`,
    ERROR_PIN_LENGTH: `O PIN não tem o comprimento correto.`,
    ERROR_RECEIVING_PAYMENT: `O terminal não conseguiu processar seu pagamento. Por favor, tente novamente.`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `Nenhum pagamento foi recebido. Este pedido não foi enviado. Seu recibo conterá um resumo do pedido. Por favor, contate um membro da equipe para obter mais ajuda.`,
    ERROR_SENDING_ORDER: `Olá, parece haver um problema ao enviar seu pedido para a cozinha. Por favor, contate um membro da equipe para obter ajuda.`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `O pagamento foi bem-sucedido, mas houve um problema ao enviar seu pedido para a cozinha. Por favor, contate um membro da equipe. Seu recibo conterá um resumo do pedido.`,
    ERROR_STARTING_ORDER: `Desculpe, não foi possível iniciar seu pedido. Por favor, tente novamente. Se o problema persistir, contate um membro da equipe.`,
    ERROR_UPDATING_ORDER: `Desculpe, não foi possível atualizar seu pedido. Por favor, tente novamente. Se o problema persistir, contate um membro da equipe.`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `Não é possível ver este item. Você atingiu o limite de álcool para este pedido. Por favor, remova uma bebida alcoólica para adicionar esta.`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `Não é possível ver este item. Você atingiu o limite de oferta especial para este pedido. Por favor, remova um item de oferta especial para adicionar este.`,
    EXIT: `Sair`,
    EXIT_CONFIRMATION: `Tem certeza de que deseja sair? Sair vai cancelar seu pedido.`,
    EXIT_TO_COVER: ``,
    FAVORITE: `Favorito`,
    FAVORITES: `Favoritos`,
    FAVORITES_NONE_YET: `Ainda não há favoritos.`,
    FAVORITES_REMOVE_CONFIRMATION: `Tem certeza de que deseja remover este favorito?`,
    FETCHING_RECOMMENDATIONS: `Buscando recomendações...`,
    FIND_ACCOUNT: `Encontrar conta`,
    FIRST_NAME: `Nome`,
    FORGOT_PASSWORD: `Esqueceu a senha?`,
    FULFILLMENT_LABEL_ADDRESS: `Endereço`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `E-mail`,
    FULFILLMENT_LABEL_GUEST_NAME: `Para`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `Número do pedido`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `Número da mesa`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `Número de telefone`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `Número do rastreador`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `Descrição do veículo`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `Seu pedido será entregue no endereço abaixo.`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `Enviaremos o recibo para você.`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `Seu nome será chamado quando o pedido estiver pronto.`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `Seu número do pedido será chamado.`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `Você receberá uma mensagem quando o pedido estiver pronto.`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `Seu pedido será servido na sua mesa.`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `Seu rastreador vai tocar quando o pedido estiver pronto.`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `Assim que você chegar na frente do restaurante, levaremos seu pedido até você.`,
    FULFILLMENT_TOGGLE: `Alternar método de retirada ativo`,
    FULL_NAME: `Nome completo`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `Desculpe! Não foi possível encontrar o menu para esse horário. Por favor, tente novamente.`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `Desculpe! Nenhum horário disponível encontrado. Por favor, tente outra opção de refeição.`,
    FUTURE_ORDER_SET_FOR: `Pedido agendado para:`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `Desculpe! O horário escolhido não está mais disponível. Por favor, selecione outro horário.`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `Ocorreu um erro ao carregar os horários disponíveis. Por favor, tente novamente. Se o problema persistir, contate um membro da equipe.`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `Por favor, selecione um horário.`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `Horários disponíveis`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `Hoje`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `Amanhã`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `Retirada hoje às {{$1: time}}`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `Retirada no próximo dia útil às {{$1: time}}`,
    FUTURE_ORDER_LEAD_TIME: `Tempo estimado de preparo: {{$1: time}}`,
    GENERIC_ERROR: `Ops! Algo deu errado. Por favor, tente novamente. Se o problema persistir, contate um membro da equipe.`,
    GET_REWARDS: `Obter recompensas`,
    GET_RECEIPT: `Obter recibo`,
    GET_RECEIPT_DIALOG_TITLE: `Opções de recibo`,
    GIFT_CARD: `Vale-presente`,
    GIFT_CARD_SECONDARY: `Vale-presente alternativo`,
    GIFT_CARD_TITLE: `Pagar agora`,
    GIFT_CARD_SUBTITLE: `Pague passando seu vale-presente na leitora de cartões.`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `Erro ao escanear vale-presente`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `Não foi possível escanear seu vale-presente. Por favor, tente novamente.`,
    GIFT_CARD_APPLYING_TITLE: `Aplicando vale-presente`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `Erro ao aplicar vale-presente`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `Não foi possível aplicar seu vale-presente. Por favor, tente novamente.`,
    GIFT_CARD_NO_BALANCE_TITLE: `Saldo insuficiente no vale-presente`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `Seu vale-presente não tem saldo.`,
    GIFT_CARD_ADD_ANOTHER: `Adicionar outro`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `Por favor, insira um número de vale-presente.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `Por favor, insira um número de vale-presente válido.`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `Por favor, insira um número de vale-presente válido.`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `Por favor, insira um PIN.`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `Por favor, insira um PIN válido.`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `Por favor, insira um PIN válido.`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `Insira o número do vale-presente. Os números podem ter {{$1: length}} dígitos.`,
    GIFT_CARD_ENTERING_PIN_HINT: `Insira o PIN. Os números podem ter {{$1: length}} dígitos.`,
    GIFT_CARD_ERROR_REMOVING: `Erro ao remover o vale-presente. Por favor, tente novamente. Se o problema persistir, contate um membro da equipe.`,
    'gift-card.select-account.title': `Selecionar conta`,
    'gift-card.select-account.loading': `Carregando contas...`,
    'gift-card.select-account.error.title': `Não foi possível carregar as contas`,
    'gift-card.select-account.error.message': `Não foi possível carregar suas contas. Por favor, tente novamente.`,
    'gift-card.select-account.column.account': `Conta`,
    'gift-card.select-account.column.balance': `Saldo atual`,
    'gift-card.select-account.error.toast-title': `Erro`,
    'gift-card.select-account.error.toast-message': `Falha na validação. Por favor, tente novamente.`,
    GLOSSARY_TERM_LEARN_MORE: `Saiba mais`,
    GOES_WELL_WITH: `Combina bem com`,
    GRAND_TOTAL: `Total geral`,
    GROUP_ORDERING_ADD_GUEST: `Adicionar convidado`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `O nome do convidado contém caracteres inválidos.`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `Este nome de convidado já está em uso. Por favor, insira um nome diferente.`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `Convidado {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `Pedido em grupo - Para quem é este item?`,
    GROUP_ORDERING_LABEL: `Pedido em grupo - Item para:`,
    GROUP_ORDERING_TITLE: `Pedido em grupo`,
    GROUP_ORDERING_SUBTITLE: `A opção de pedido em grupo perguntará a qual membro do seu grupo cada item pertence. Toque em "Sim" para ativar o pedido em grupo. Toque em "Não" para continuar.`,
    GUEST_INFO: `Informações do convidado`,
    GUEST_RATING_LABEL_0: `Toque para avaliar como 0: Muito insatisfeito`,
    GUEST_RATING_LABEL_1: `Toque para avaliar como 1: Um pouco insatisfeito`,
    GUEST_RATING_LABEL_2: `Toque para avaliar como 2: Um pouco satisfeito`,
    GUEST_RATING_LABEL_3: `Toque para avaliar como 3: Muito satisfeito`,
    GUEST_RATING_0: `Obrigado por nos dar sua opinião!`,
    GUEST_RATING_1: `Obrigado por nos dar sua opinião!`,
    GUEST_RATING_2: `Obrigado por nos dar sua opinião!`,
    GUEST_RATING_3: `Obrigado por nos dar sua opinião!`,
    GUEST_RATING_SUBMITTED: `Obrigado por nos dar sua opinião!`,
    HIDE: `Ocultar`,
    HOME: `Início`,
    HOW_DID_WE_DO: `Como nos saímos? Avalie-nos!`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `Como gostaria de pagar?`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `Como gostaria de receber seu pedido?`,
    KITCHEN_CLOSED: `Desculpe, a cozinha está fechada.`,
    ID_CHECK_LABEL: `Seu pedido contém álcool. Pode ser solicitado que você apresente identificação.`,
    ID_CHECK_CODE_MESSAGE: `É necessário um código de acesso de funcionário para pagar com álcool. Por favor, solicite ajuda a um membro da equipe.`,
    IE_WARNING: `Constatamos que você está usando o Internet Explorer. Nosso site é melhor visualizado em navegadores compatíveis, como Google Chrome, Safari, Firefox ou Microsoft Edge`,
    INCLUDE_UTENSILS: `Incluir talheres`,
    ITEM_86D: `Olá, parece haver um problema ao enviar seu pedido para a cozinha porque um item está esgotado. Por favor, contate um membro da equipe para obter ajuda.`,
    ITEM_86D_VALIDATION: `Olá. Infelizmente, não estamos conseguindo enviar seu pedido à cozinha, pois há pelo menos um item em falta. Entre em contato com nossa equipe para obter ajuda.`,
    ITEM_RECIPIENT: `Preparado para`,
    ITEM_RECIPIENT_FOR: `Preparado para {{$1: recipient}}`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `Recomendado`,
    ITEM_STEP_TITLE: `Etapa {{$1: step}}`,
    ITEM_STEP_EMPTY: `Nenhuma escolha feita nesta etapa`,
    ITEM_STEP_NO_RECOS: `Nenhuma recomendação disponível`,
    ITEMS_NO_LONGER_IN_MENU: `Alguns itens foram removidos do seu carrinho pois não estão mais no menu`,
    ITEM_SCAN_ERROR: `Não encontramos este item. Por favor, adicione-o pelo menu ou peça ajuda a um membro da equipe.`,
    ITEM_SCAN_SUCCESS: `Item adicionado ao carrinho!`,
    LAST_NAME: `Sobrenome`,
    LEAD_TIME_LONG: `Seu pedido pode levar mais tempo do que o horário atualmente selecionado.`,
    LEAD_TIME_CART: `Este pedido pode levar mais tempo para ser preparado do que o horário de retirada solicitado devido a alguns itens selecionados.`,
    LANGUAGE_SELECT_LABEL: `Toque para selecionar o idioma`,
    LOADING: `Carregando...`,
    LOADING_MENU: `Carregando menu...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `Buscar restaurantes`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `Encontrar restaurante para {{$1: dine-in/take-away}}`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `Como gostaria de pedir?`,
    LOCATION_SEARCH_HEADER: `Bem-vindo ao {{$1: org name}}`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `Endereço, cidade e estado, ou CEP`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `Entrar`,
    LOGIN: `Entrar`,
    LOGIN_GIFT_CARD: `Login com vale-presente`,
    LOGIN_GIFT_CARD_SECONDARY: `Login com vale-presente alternativo`,
    LOGIN_WALL_WELCOME: `Olá!`,
    LOGIN_WALL_WELCOME_USER: `Olá, {{$1: user}}!`,
    LOGIN_WITH_CARD_NUMBER: `Entrar com número do cartão`,
    LOGIN_WITH_PHONE: `Entrar com telefone`,
    LOOKING_UP_ACCOUNT: `Buscando conta...`,
    LOOKUP_CARD: `Buscando cartão...`,
    LOOKUP_COUPON: `Buscando cupom...`,
    LOYALTY: `Programa de fidelidade`,
    LOYALTY_ACCOUNT_APPLY: `Aplicar`,
    LOYALTY_CARD_NUMBER: `Número do cartão`,
    LOYALTY_EXIT_TO_MENU: `Ir ao menu`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `Escanear QR code do aplicativo`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `Sem aplicativo? Insira seu número de telefone.`,
    LOYALTY_AUTH_METHOD_BARCODE: `Escanear QR code do aplicativo`,
    LOYALTY_AUTH_METHOD_HID: `Toque o cartão HID`,
    LOYALTY_AUTH_METHOD_PHONE: `Insira seu número de telefone.`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `Insira seu número de cartão.`,
    LOYALTY_AUTH_METHOD_EMAIL: `Insira seu e-mail.`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `Insira seu e-mail e senha.`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `Insira seu e-mail e número de telefone.`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `Insira seu nome de usuário e senha.`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `Insira o número de telefone da sua conta:`,
    LOYALTY_APP_AUTH_SUBTITLE: `Para encontrar o código de barras, abra seu aplicativo na tela PAGAR.`,
    LOYALTY_APP_AUTH_TITLE: `Escaneie o código de barras de pagamento do seu aplicativo com o scanner abaixo.`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `Inserir manualmente o código de recompensa de 7 dígitos`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `Insira um código de recompensa de 7 dígitos:`,
    LOYALTY_APPLY_REWARD_FAILED: `Falha ao aplicar recompensa. Por favor, tente novamente.`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `Não foi possível aplicar as seguintes recompensas: {{$1: reward names}}. Por favor, tente novamente.`,
    LOYALTY_APPLYING_REWARD: `Aplicando recompensa...`,
    LOYALTY_AUTH_GENERIC_ERROR: `Desculpe! Não foi possível encontrar esta conta de recompensas. Por favor, tente novamente.`,
    LOYALTY_AUTH_INSTRUCTIONS: `Faça login para ganhar e usar seus pontos do programa de recompensas.`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `Recompensas disponíveis`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `Saldo atual`,
    LOYALTY_CANNOT_MODIFY_REWARD: `Desculpe, você não pode modificar suas recompensas depois de pagar o pedido.`,
    LOYALTY_CANNOT_REMOVE_REWARD: `Desculpe, esta recompensa não pode ser removida depois de aplicada ao pedido.`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `Insira seu número de cartão para ganhar e usar seus pontos do programa de recompensas.`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `Desculpe, você não pode usar suas recompensas porque há um cupom aplicado.`,
    LOYALTY_GETTING_REWARDS: `Carregando suas recompensas...`,
    LOYALTY_FETCH_REWARDS_FAILED: `Falha ao carregar recompensas. Por favor, tente novamente.`,
    LOYALTY_REWARD_APPLY: `Aplicar`,
    LOYALTY_REWARD_APPLY_FAILED: `Falha ao aplicar recompensas. Algumas recompensas podem não se aplicar ao seu pedido.`,
    LOYALTY_REWARD_APPLIED: `Aplicado`,
    LOYALTY_REWARD_INVALID: `Inválido`,
    LOYALTY_REWARD_LABEL_MEAL: `Refeição`,
    LOYALTY_REWARD_LABEL_MEALS: `Refeições`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `Resgatar agora`,
    LOYALTY_REWARD_LABEL_SELECTED: `Selecionado`,
    LOYALTY_REWARD_LABEL_APPLIED: `Resgatado`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `Resgatar no checkout`,
    LOYALTY_REWARD_LABEL_REMOVING: `Removendo`,
    LOYALTY_REWARD_LABEL_ERROR: `Erro ao aplicar`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `Não aplicável`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `Recompensas`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `Recompensas por porcentagem`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `Recompensas fixas`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `Recompensas de carteira`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `Recompensas de carteira e pagamento`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `Recompensas de item gratuito`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `Recompensas de troca de refeição`,
    LOYALTY_REWARDS_FOR: `para`,
    LOYALTY_NO_REWARDS_LABEL: `Sem recompensas`,
    LOYALTY_NO_REWARDS_NO_EARNING: `Não há recompensas aplicáveis para estes itens.`,
    LOYALTY_NO_REWARDS_TEXT: `Não há recompensas aplicáveis para estes itens, mas você ainda vai ganhar pontos com este pedido!`,
    LOYALTY_PAYMENT: `Com programa de fidelidade`,
    LOYALTY_PAYMENT_CARD_CHARGED: `{{$1: charge_amount}} será cobrado no cartão cadastrado.`,
    LOYALTY_PAYMENT_FAILED: `Falha ao aplicar pagamento.`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `Houve um problema ao processar o pagamento do programa de fidelidade. Por favor, tente novamente ou escolha outro método de pagamento.`,
    USE_LOYALTY_PAYMENT: `Usar programa de fidelidade`,
    LOYALTY_PAYMENT_SUBMIT: `Concluir pagamento`,
    LOYALTY_PAYMENT_REWARD: `Cobrado no programa de fidelidade`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `O cartão cadastrado no provedor será cobrado por esta transação.`,
    LOYALTY_PAY_WITH_APP: `Pagar com o aplicativo`,
    LOYALTY_EARNED_POINT_ESTIMATE: `Pontos de recompensa estimados para este pedido:`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number}} pontos`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `Status da conta`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `Não encontramos sua conta.`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `Por favor, faça login na sua conta abaixo para ganhar pontos e resgatar recompensas.`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `Cadastrar com número de telefone`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `Você ainda pode ganhar pontos no pedido de hoje escaneando o recibo após o cadastro!`,
    LOYALTY_INTRO_QR_SIGN_IN: `Por favor, escaneie seu QR code abaixo para fazer login.`,
    LOYALTY_INTRO_QR_SIGN_UP: `Por favor, escaneie o QR code abaixo para se cadastrar.`,
    LOYALTY_INTRO_WELCOME_BACK: `Bem-vindo de volta,`,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `O número de telefone fornecido está associado a mais de uma conta de fidelidade ou não existe.`,
    LOYALTY_REDEMPTION_CODE: `Aplicar código de resgate`,
    LOYALTY_REMOVING_REWARD: `Removendo recompensa...`,
    LOYALTY_SCAN_FAILED_TITLE: `Falha ao escanear`,
    LOYALTY_SCAN_FAILED_MESSAGE: `Não foi possível escanear seu QR code. Por favor, tente novamente.`,
    LOYALTY_SIGN_OUT_NOTICE: `Você será desconectado automaticamente quando o pedido for feito ou ao sair do menu.`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `Você será desconectado automaticamente quando o pedido for feito ou ao sair do menu. As senhas nunca são salvas.`,
    LOYALTY_SIGN_UP_SMS_SENT: `Mensagem de cadastro enviada!`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `Voltar ao login`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `Cadastro realizado com sucesso!`,
    LOYALTY_SIGN_UP_WITH_QR: `Cadastrar com QR code`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `Cadastrar com número de telefone`,
    LOYALTY_WELCOME_TITLE: `Ganhe e use recompensas`,
    LOYALTY_SIGNUP_TITLE: `Receba um link de cadastro no seu telefone`,
    LOYALTY_YOU_CURRENTLY_HAVE: `Você tem atualmente`,
    LOYALTY_NAV_REWARDS: `Minhas recompensas`,
    LOYALTY_NAV_ORDER_HISTORY: `Meus pedidos`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `Você excedeu o número máximo de tentativas de login.`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `Você excedeu o número máximo de tentativas de acesso ao vale-presente.`,
    MAKE_IT_A_COMBO: `Fazer um combo?`,
    MAKE_IT_A_COMBO_MOD: `Transformar em combo?`,
    MAKE_IT_A_COMBO_ACCEPT: `Sim, por favor!`,
    MAKE_IT_A_COMBO_REJECT: `Não, obrigado!`,
    MAKE_IT_A_COMBO_NO: `Não, obrigado, sem combo.`,
    MAKE_IT_A_COMBO_YES: `Fazer um combo?`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `Ótima escolha!`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `Escolha seu acompanhamento e bebida abaixo!`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `Adicione um acompanhamento e uma bebida para fazer um combo!`,
    MENU_COVER_ALT_TEXT: `Toque aqui para começar a pedir`,
    MENU_COVER_LOYALTY_TEXT: `Faça login no programa de fidelidade para ganhar pontos e resgatar recompensas`,
    MENU_COVER_QUIZ_TEXT: `Faça o quiz para descobrir qual item é ideal para você!`,
    MENU_COVER_WAYFINDER_TEXT: `Acesse nosso guia de orientação para encontrar seu destino`,
    MAINTENANCE_COVER_TITLE: `Este quiosque está em manutenção`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `Por favor, certifique-se de que o HID está conectado ao quiosque.`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID desconectado`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `Por favor, certifique-se de que o KDS está conectado ao quiosque.`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS desconectado`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `Por favor, tente outro quiosque ou peça ajuda a um membro da equipe.`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `Este quiosque está indisponível no momento`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `Por favor, certifique-se de que o leitor de tarja magnética está conectado ao quiosque.`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `Leitor de tarja magnética desconectado`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `Por favor, certifique-se de que o quiosque está conectado à rede.`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `Sem conexão de rede`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `Este quiosque está com problemas de conexão devido à velocidade lenta de internet. Por favor, verifique se sua conexão está estável. Velocidade recomendada: mínimo de 10 Mbps de upload e download.`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `Rede instável detectada`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `Por favor, certifique-se de que o dispositivo de pagamento está ligado e conectado ao quiosque.`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `Dispositivo de pagamento desconectado`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `Por favor, certifique-se de que a tampa da impressora está fechada.`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `Tampa da impressora aberta`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `Por favor, certifique-se de que a impressora está conectada ao quiosque.`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `Impressora desconectada`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `Por favor, certifique-se de que a impressora tem papel.`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `Impressora sem papel`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `Por favor, certifique-se de que a balança está conectada ao quiosque.`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `Balança desconectada`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `Por favor, certifique-se de que o scanner está conectado ao quiosque.`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `Scanner desconectado`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `O limite máximo de bebidas alcoólicas por pedido é {{$1: number}}`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `O limite máximo de itens especiais por pedido é {{$1: number}}`,
    MENU_COVER_DINING_OPTIONS: `Como gostaria de pedir?`,
    MENU_COVER_LANGUAGE_OPTIONS: `Selecione um idioma para começar`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `Toque aqui para iniciar o pedido e ver este item em destaque: {{$1: item name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `Toque aqui para iniciar o pedido e ir direto para esta seção em destaque: {{$1: section name}}!`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `Toque aqui para iniciar o pedido e ir direto para esta página em destaque: {{$1: page name}}!`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `Toque aqui para iniciar o pedido "{{$1: fulfillment method}}"!`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `Voltar às opções de refeição`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `Voltar ao número de telefone`,
    MARKETING_CONSENT: `Desejo receber novidades, atualizações, descontos e ofertas`,
    MENU_FILTERS_DIETARY_FILTERS: `Opções dietéticas`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `Para alternativas mais saudáveis, selecione uma única opção para que só ela seja mostrada no menu`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `Preferências nutricionais`,
    MENU_FILTERS_OTHER_FILTERS: `Outros`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `Restritivo`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `Caso tenha alguma intolerância, selecione uma das opções para ocultá-la no menu`,
    MENU_FILTERS_COUNT: `{{$1: number}} preferências nutricionais ativas. Toque para editar.`,
    MOD_86D: `Olá. Infelizmente, não estamos conseguindo enviar seu pedido à cozinha, pois há pelo menos um item em falta. Entre em contato com nossa equipe para obter ajuda. Observe que o pagamento FOI EFETUADO normalmente pelo restaurante.`,
    MOD_GROUP_AGGREGATE_QUANTITY: `{{$1: number range, e.g. 2-3}} itens no total`,
    MOD_GROUP_CHOICES_INCREMENT: `múltiplos de {{$1: number, e.g. you have to get 2/4/6 sauces}}`,
    MOD_GROUP_CHOICES_MAKE_ONE: `faça uma única escolha`,
    MOD_GROUP_CHOICES_MAKE_X: `faça {{$1: number range, e.g. 2-3}} escolhas diferentes`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `{{$1: number range, e.g. 2-3}} por escolha`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `Escolher pelo menos {{$1: number}}`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `Escolher entre {{$1: number}} e {{$2: number}}`,
    MOD_GROUP_CHOOSE_ONE: `Escolher um`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `Escolher até um`,
    MOD_GROUP_CHOOSE_UP_TO_X: `Escolher até {{$1: number}}`,
    MOD_GROUP_CHOOSE_X: `Escolher {{$1: number}}`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `Mostrar - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `Ocultar - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: `{{$1: dollar amount}} restantes para começar a ser cobrado.`,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: `Opções adicionais a {{$1: dollar amount}} por item.`,
    MOD_GROUP_WALLET_FIRST_X_FREE: `Os primeiros {{$1: number}} são gratuitos.`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `O primeiro é gratuito.`,
    MOD_GROUP_WALLET_UP_TO_X: `Até {{$1: number}} por {{$2: dollar amount}} o item`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `Fechar substituição`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `Alterar substituição`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `Substituir`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `Adicionar ao item`,
    MOD_RECOMMENDED_BADGE: `Recomendado`,
    MOD_UPSELL_PROMPT_TITLE: `Adicionar uma opção?`,
    MOD_UPSELL_PROMPT_ACCEPT: `Adicionar`,
    MOD_UPSELL_PROMPT_DECLINE: `Não, obrigado`,
    MODIFY: `Modificar`,
    MODIFY_INGREDIENTS: `Modificar ingredientes`,
    MORE: `mais`,
    NAME_CALLED_ORDER_READY: `Seu nome será chamado quando o pedido estiver pronto.`,
    NAME_ON_CARD: `Nome no cartão`,
    NEED_MORE_TIME: `Precisa de mais tempo?`,
    NEW_PASSWORD: `Nova senha`,
    NEXT: `Próximo`,
    NO: `Não`,
    NO_ITEMS_MATCH_FILTERS: `Nenhum item corresponde aos seus filtros.`,
    NO_ORDERS_MATCH: `Nenhum pedido corresponde à sua busca.`,
    NO_THANKS: `Não, obrigado`,
    NO_TIP: `Sem gorjeta`,
    NOT_A_MEMBER: `Ainda não é membro?`,
    NUTRITION_INFO_CALORIES: `Calorias`,
    NUTRITION_INFO_PROTEIN: `Proteínas`,
    NUTRITION_INFO_FAT: `Gorduras`,
    NUTRITION_INFO_CARBS: `Carboidratos`,
    NUTRITION_INFO_SUGAR: `Açúcares`,
    OK: `OK`,
    OR: `ou`,
    OPT_OUT_OF_RECOMMENDATIONS: `Recusar recomendações`,
    ORDER_GET_ERROR: `Desculpe, tivemos problemas ao criar seu pedido. Por favor, tente novamente.`,
    ORDER_HISTORY: `Histórico de pedidos`,
    ORDER_HISTORY_EMPTY: `Não há pedidos no seu histórico. Quando você fizer um pedido, ele aparecerá aqui.`,
    ORDER_HISTORY_ERROR: `Desculpe, tivemos problemas ao carregar seu histórico de pedidos. Por favor, tente novamente.`,
    ORDER_SENT: `Pedido enviado`,
    ORDER_SUMMARY: `Resumo do pedido`,
    ORDER_SUMMARY_WITH_NAME: `Resumo do pedido de {{$1 guest name}}`,
    ORDER_SUMMARY_LABEL: `Resumo do pedido. Pedido {{$1 fulfillment}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `Resumo do pedido. Pedido {{$1 fulfillment}} para {{$2 guest name}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `Resumo do pedido. Pedido {{$1 fulfillment}} para a mesa {{$2: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `Resumo do pedido. Pedido {{$1 fulfillment}} para o rastreador #{{$2: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `Resumo do pedido. Pedido {{$1 fulfillment}} para {{$2 guest name}} na mesa {{$3: table number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `Resumo do pedido. Pedido {{$1 fulfillment}} para {{$2 guest name}} no rastreador #{{$3: tracker number}}`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `Resumo do pedido. Pedido {{$1 fulfillment}} para o pedido #{{$2: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `Resumo do pedido. Pedido {{$1 fulfillment}} para o rastreador #{{$2: tracker number}} para o pedido #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `Resumo do pedido. Pedido {{$1 fulfillment}} para a mesa {{$2: table number}} para o pedido #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `Resumo do pedido. Pedido {{$1 fulfillment}} para {{$2 guest name}} para o pedido #{{$3: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `Resumo do pedido. Pedido {{$1 fulfillment}} para {{$2 guest name}} na mesa {{$3: table number}} para o pedido #{{$4: order number}}`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `Resumo do pedido. Pedido {{$1 fulfillment}} para {{$2 guest name}} no rastreador #{{$3: tracker number}} para o pedido #{{$4: order number}}`,
    ORDER_THROTTLE_MAX_EXCEEDED: `Desculpe! O restaurante está recebendo mais pedidos do que consegue atender. Por favor, tente com um horário diferente.`,
    ORDER_TIME_ASAP: `Pedir o mais rápido possível`,
    ORDER_TIME_LATER: `Mais tarde hoje`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `Próximo dia útil`,
    ORDER_TIME_FUTURE: `Pedir para mais tarde`,
    ORDER_TOTAL_MAX_EXCEEDED: `Para pedidos grandes, por favor, consulte um membro da equipe.`,
    ORDER_UPDATE_FAILED: `Falha ao atualizar pedido.`,
    ORDER_VALIDATION_IN_PROGRESS: `Validando seu pedido`,
    ORDER_VALIDATION_FAILED: `Ops! Ocorreu um erro.`,
    ORDER_WAS_PLACED: `Seu pedido foi feito.`,
    ORDERING_MODE_CHANGED: `Modo de pedido alterado. Sua sessão foi reiniciada.`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `Toque aqui para transformar {{$1: ordered item name}} em um combo.`,
    ORDERED_ITEM_COMBO_LABEL: `Combo`,
    ORDERING_ITEM_ABSENCE_RESET: `Este item estava desatualizado. O item foi restaurado ao seu estado inicial. Por favor, tente novamente.`,
    OUR_MENU: `Nosso menu`,
    OUTPOST_PICKUP: `Retirada no posto avançado`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `Insira o número do quarto do posto avançado`,
    OUTPOST_ROOM_NUMBER_TITLE: `Número do quarto`,
    OUT_OF_STOCK: `Esgotado`,
    PAGE_NAVIGATION_TITLE: `Toque em uma das opções abaixo para ir a uma página específica do menu. {{$1: total}} páginas disponíveis.`,
    PARTIAL_PAYMENT_LINE: `Pagamento parcial`,
    PARTIAL_PAYMENT_WARNING_TITLE: `Pagamento parcial`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `Há um pagamento parcial neste pedido. Se quiser voltar, seu pagamento será reembolsado primeiro.`,
    PASSWORD: `Senha`,
    PARTIAL_TENDER_TIMEOUT: `Olá, se você não concluir o pagamento nos próximos 5 minutos, cancelaremos o pedido e reembolsaremos seu pagamento.`,
    PAY_AT_CASHIER: `Por favor, dirija-se ao caixa para pagar.`,
    PAY_NOW: `Pagar agora`,
    PAY_WITH: `Pagar com`,
    PAY_WITH_CREDIT: `Pagar com cartão de crédito`,
    PAY_WITH_DEBIT_CREDIT: `Pagar com débito/crédito`,
    PAYMENT: `Pagamento`,
    PAYMENT_DETAILS: `Detalhes do pagamento`,
    PAYMENT_LINE_LABEL_DONATION: `Doação de {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `O subtotal é {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `Pagamento parcial de {{$1: amount}}`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `Resgate de vale-presente de {{$1: name}} no valor de {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `Desconto de cupom de {{$1: name}} no valor de {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `Desconto de cupom de {{$1: name}} no valor de {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `Pagamento com EBT no valor de {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `Resgate de recompensas de {{$1: name}} no valor de {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `Resgate de recompensa de {{$1: name}} no valor de {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `Desconto de {{$1: name}} no valor de {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `O imposto é {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `A gorjeta é {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `A taxa de serviço é {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `A taxa de serviço é {{$1: amount}} para {{$2: name}}`,
    PAYMENT_LINE_LABEL_TOTAL: `O total geral é {{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `O saldo restante é {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `O valor pago é {{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `Toque para pagar em dinheiro`,
    PAYMENT_OPTION_LABEL_CARD: `Toque para pagar com cartão de crédito`,
    PAYMENT_OPTION_LABEL_COUPON: `Toque para resgatar um cupom`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `Toque para resgatar um cartão de cortesia`,
    PAYMENT_OPTION_LABEL_DONATION: `Toque para fazer ou editar doações`,
    PAYMENT_OPTION_LABEL_EBT: `Toque para pagar com EBT`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `Toque para reembolsar EBT`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `Toque para pagar com benefício em dinheiro do EBT`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `Toque para pagar com vale-alimentação do EBT`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `Toque para pagar com um vale-presente`,
    PAYMENT_OPTION_LABEL_LOYALTY: `Toque para resgatar recompensas`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `Toque para resgatar recompensas`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `Toque para concluir o pagamento`,
    PAYMENT_PROMPT_NFC: `Pague na leitora de cartões inserindo seu cartão ou aproximando seu celular.`,
    PAYMENT_PROMPT_DIP: `Pague na leitora de cartões inserindo seu cartão.`,
    PAYMENT_SUCCESSFUL: `Pagamento realizado com sucesso`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `Desculpe, seu pagamento falhou. Por favor, tente novamente.`,
    PAYMENT_KIOSK_TIMEOUT: `Desculpe, a sessão de pagamento expirou. Por favor, tente novamente.`,
    PAYMENT_TOTAL: `Total do pagamento`,
    PAYMENT_WAS_TAKEN: `Observe que seu pagamento foi processado.`,
    PAYMENT_WAS_NOT_TAKEN: `Observe que seu pagamento não foi processado. Isto não é uma confirmação de pagamento.`,
    PHONE_NUMBER: `Número de telefone`,
    PICK_UP: `Retirada`,
    PICK_UP_AT: `Retirada em`,
    PICK_UP_ENTER_NUMBER: `Por favor, pegue um número e insira-o abaixo:`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `Olá {{$1: guest name}}, por favor pegue um número e insira-o abaixo:`,
    PICK_UP_ENTER_NUMBER_TRACKER: `Por favor, pegue um rastreador e insira seu número:`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `Olá {{$1: guest name}}, por favor pegue um rastreador e insira seu número:`,
    PLACE_ORDER: `Fazer pedido`,
    PLEASE_ENTER_A_VALID_AMOUNT: `Por favor, insira um valor válido para reembolsar.`,
    PLEASE_USE_TEST_CARD: `Este local ainda está em modo de teste. Por favor, use um cartão de teste para pagar.`,
    PLEASE_WAIT: `Aguarde, por favor...`,
    PRICE: `O preço é {{$1:price}}`,
    PRINTING_RECEIPT: `Imprimindo seu recibo...`,
    PRINT_RECEIPT: `Imprimir recibo`,
    PRINT_RECEIPT_ERROR: `Desculpe, ocorreu um erro ao imprimir seu recibo. Por favor, tente novamente mais tarde.`,
    PRINTED_RECEIPT_COMMAND: `Por favor, lembre-se de pegar seu recibo!`,
    PROCESSING_PAYMENT: `Processando pagamento...`,
    PROMOTED_MODIFIER: `Promovido!`,
    QUANTITY_SELECT: `{{$1:quantity}} selecionado!`,
    QUANTITY_SELECT_INCREASE: `Aumentar quantidade`,
    QUANTITY_SELECT_DECREASE: `Diminuir quantidade`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `Sair`,
    QUICK_CHECKOUT: `Checkout rápido`,
    QUICK_NAV_TAP_TO_VIEW: `Toque para ver:`,
    QUIZ_RESULTS_TITLE: `Resultados`,
    QUIZ_RESULTS_EMPTY: `Nenhum resultado encontrado. Tente novamente com outras respostas.`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `Toque para ver o próximo resultado. {{$1:index}} de {{$2:total}}`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `Toque para ver o resultado anterior. {{$1:index}} de {{$2:total}}`,
    QUIZ_STEP_ERROR: `Por favor, responda todas as perguntas antes de continuar.`,
    QUIZ_STEP_ANSWER_LABEL: `Toque para responder com {{$1:badge name}}:`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `Escaneie o QR code para receber uma cópia do seu recibo no celular.`,
    RECEIPT_AUTHORIZATION: `Autorização`,
    RECEIPT_CARD_NUMBER: `Nº do cartão`,
    RECEIPT_CHECK_ID: `Nº RECIBO`,
    RECEIPT_DISCOUNTS: `Descontos`,
    RECEIPT_DONATION: `Doação`,
    RECEIPT_FAILED: `Olá, parece haver um problema ao enviar seu pedido para a cozinha. Por favor, contate um membro da equipe para obter ajuda.`,
    RECEIPT_FAILED_ITEM_86D: `Olá. Infelizmente, não estamos conseguindo enviar seu pedido à cozinha, pois há pelo menos um item em falta. Entre em contato com nossa equipe para obter ajuda.`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `Os itens abaixo não foram incluídos no QR Code por não terem PLU:`,
    RECEIPT_NOT_RECEIPT: `Isto não é um recibo nem comprovante de compra.`,
    RECEIPT_ORDER: `PEDIDO`,
    RECEIPT_ORDER_TOTAL: `Total do pedido`,
    RECEIPT_PAY_AT_CASHIER: `POR FAVOR, PAGUE NO CAIXA`,
    RECEIPT_PICK_UP_AT_LABEL: `Retirar em`,
    RECEIPT_PICKUP_TIME_LABEL: `Horário de retirada`,
    RECEIPT_DELIVERY_TIME_LABEL: `Horário de entrega`,
    RECEIPT_PRINTED: `Recibo impresso`,
    RECEIPT_REFUNDED: `Reembolsado`,
    RECEIPT_REMAINING_BALANCE: `Saldo restante`,
    RECEIPT_SELF_SERVE: `Autoatendimento:`,
    RECEIPT_SPECIAL_REQUEST: `Pedido especial`,
    RECEIPT_SUB_TOTAL: `Subtotal`,
    RECEIPT_TAX_TOTAL: `Total de impostos`,
    RECEIPT_TIP_THANKS: `Gorjeta (Obrigado!)`,
    RECEIPT_SERVICE_CHARGE: `Taxa de serviço`,
    RECEIPT_TRANS_NO: `Nº TRANSAÇ. CAIXA`,
    RECEIPT_YOUR_CHECK_NUMBER: `Seu número de conta é`,
    RECOMMENDATIONS: `Recomendações`,
    RECOMMENDED_FOR_YOU: `Recomendado para você`,
    REFUND: `Reembolso`,
    REFUNDER_ALREADY_REFUNDED: `Reembolsado`,
    REFUNDER_DELAY_MESSAGE: `Os reembolsos podem levar alguns dias para aparecer no extrato da sua conta.`,
    REFUNDER_INSTRUCTIONS: `Busque pedidos por número de autorização do recibo, número do pedido, e-mail, número de telefone, quatro últimos dígitos do cartão, número de referência da transação ou número de identificação do pedido (orderID).`,
    REFUNDER_SEARCH_PLACEHOLDER: `Número de autorização do recibo, número do pedido ou últimos quatro dígitos do cartão`,
    REFUNDER_TITLE: `Reembolsar pedido`,
    REFUNDER_SEARCHING_TITLE: `Buscando`,
    REFUNDER_RESULTS_TITLE: `Pedidos`,
    REFUNDER_RESULTS_EMPTY: `Nenhum pedido encontrado. Por favor, verifique seus critérios de busca e tente novamente.`,
    REFUNDER_REFUNDING_TITLE: `Reembolsando`,
    REFUNDER_REFUND_ERROR: `Ocorreu um erro ao processar seu reembolso. Por favor, tente novamente. Se o problema persistir, contate o suporte.`,
    REFUNDER_REFUND_SUCCESS: `Reembolso realizado com sucesso! A transação será processada em breve.`,
    REFUNDER_REFUND_SUCCESS_BACK: `Buscar novamente`,
    REFUNDER_SEARCH_INPUT_ERROR: `Por favor, insira um número de autorização, número de pedido ou os últimos quatro dígitos do cartão válidos.`,
    REFUNDER_SEARCH_ERROR: `Ocorreu um erro ao buscar seu pedido. Por favor, tente novamente. Se o problema persistir, contate o suporte.`,
    REFUNDING: `Processando reembolso...`,
    REFUND_FAILED: `O reembolso falhou. Por favor, tente novamente mais tarde.`,
    REMOVE: `Remover`,
    REMOVE_CARD: `Não se esqueça de retirar seu cartão.`,
    REMOVE_COMP_CARD: `Remover cartão de cortesia`,
    REMOVE_COUPON: `Remover cupom`,
    REMOVE_GIFT_CARD: `Remover`,
    REMOVE_TIP: `Remover gorjeta`,
    REMOVING_COUPON: `Removendo cupom...`,
    REPEAT_PASSWORD: `Repetir senha`,
    RESET: `Redefinir`,
    REWARDS: `Recompensas`,
    REWARDS_LOGGED_IN: `Recompensas`,
    REWARDS_APPLICABLE_TO_ORDER: `Aplicável agora ao seu pedido`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `Ainda não aplicável ao seu pedido`,
    REWARDS_EDIT: `Editar recompensas`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} pontos`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}} refeições`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} pontos`,
    SAVE: `Atualizar`,
    SAVE_CARD: `Salvar cartão na conta para compras futuras.`,
    SCAN_COUPON_BELOW: `Você pode escanear cupons com o scanner abaixo.`,
    SCAN_YOUR_GIFT_CARD: `Escanear vale-presente`,
    SEARCH: `Buscar`,
    SEARCH_BEGIN: `Digite seu termo de busca abaixo para começar a pesquisar.`,
    SEARCH_EMPTY: `Nenhum resultado encontrado. Tente outro termo de busca.`,
    SEARCH_HINT: `Busque itens usando qualquer combinação de nome ou descrição.`,
    SECRET_MENU_IMAGE_ALT: `Toque para ver o menu secreto`,
    SELECT_DATE: `Selecionar data`,
    SELF_SERVE: `Autoatendimento`,
    SEND: `Enviar`,
    SEND_LOYALTY_SMS: `Enviar SMS`,
    SEND_ORDER_UI_TIMEOUT: `Olá. Ainda estamos tentando enviar seu pedido à cozinha. Entre em contato com nossa equipe para obter ajuda.`,
    SENT_LOYALTY_SIGNUP_SMS: `Mensagem de texto enviada! Verifique o celular e crie sua conta!`,
    SENDING_ORDER_KITCHEN: `Enviando pedido para a cozinha...`,
    SENDING_ORDER_VALIDATION: `Confirmando pedido...`,
    SENDING_RECEIPT: `Enviando recibo...`,
    SENDING_SMS: `Enviando mensagem de texto...`,
    SERVICE_CHARGE: `Taxa de serviço`,
    SHOW: `Exibir`,
    SHOW_NUTRITION: `Exibir informações nutricionais`,
    SHOW_STAFF_FIRST: `Mostre esta mensagem a nossa equipe antes de sair.\nDeseja sair?`,
    SIGNUP_CTA: `Crie sua conta!`,
    SIGN_OUT: `Sair`,
    SIGN_UP: `Cadastrar`,
    SIGNUP_BENEFITS: `Crie uma conta para salvar seu cartão de crédito e itens favoritos para um checkout mais rápido.`,
    SIGNUP_LOYALTY: `Cadastrar no programa de fidelidade`,
    SKIP: `Pular`,
    SPECIAL_REQUESTS: `Pedidos especiais`,
    SPECIAL_REQUESTS_EXAMPLE: `ex: molho à parte, sem anchovas, etc.`,
    SPECIAL_REQUESTS_FINEPRINT: `Substituições e pedidos podem gerar custos adicionais.`,
    SPECIAL_REQUESTS_ADD: `Adicionar pedido especial`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `O pedido especial é muito longo.`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `Por favor, use apenas letras, números e pontuação.`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `Por favor, insira uma solicitação especial.`,
    SR_REMOVE_ITEM_FROM_CART: `Remover item do carrinho.`,
    STARTING_ORDER: `Iniciando pedido...`,
    UPDATING_ORDER: `Atualizando pedido...`,
    START_ORDER_BY_SCANNING: `Comece seu pedido escaneando um item na parte inferior do quiosque.`,
    START_NEW_ORDER: `Fazer outro pedido`,
    STORED_VALUE_REMAINING_BALANCE: `restantes`,
    STORE_INFO: ``,
    STORE_INFORMATION: `Informações do restaurante`,
    STUDENT_CARD: `Cartão estudantil`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `Desculpe, este cartão estudantil não tem saldo suficiente.`,
    STUDENT_CARD_SUBTITLE_HID: `Toque seu cartão estudantil para pagar`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `Toque ou passe seu cartão estudantil para pagar`,
    STUDENT_CARD_SUBTITLE_MSR: `Passe seu cartão estudantil para pagar`,
    SUBMIT: `Enviar`,
    SUBTOTAL: `Subtotal`,
    SUBTOTAL_REDUCED: `Subtotal descontado`,
    SUBTOTAL_INCREASED: `Novo subtotal`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `Você está economizando com um combo!`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `Você economiza`,
    SUCCESS: `Sucesso`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `Trocar de local`,
    SWITCH_TO_CATERING: `Mudar para catering`,
    SWITCH_TO_WEB: `Mudar para pedido online`,
    SWIPE_YOUR_GIFT_CARD: `Passe seu vale-presente para pagar`,
    SWIPE_YOUR_COMP_CARD: `Passe seu cartão de cortesia para pagar`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `Passe ou escaneie seu vale-presente para pagar`,
    TAKING_LONGER_THAN_USUAL: `Demorando mais que o usual...`,
    TAP_HERE_FOR_LANGUAGE: `Toque aqui para {{$1: language}}`,
    TAP_OUTSIDE_CLOSE: `Toque fora para fechar`,
    TAP_TO_REDEEM: `Toque para resgatar`,
    TAXES: `Impostos`,
    TERMS_OF_SERVICE: `Termos de serviço`,
    TERMS_OF_SERVICE_LOAD_FAILED: `Erro ao carregar os termos de serviço`,
    TEXT_RECEIPT: `Recibo por SMS`,
    TEXT_RECEIPT_SEND_FAILED: `Não foi possível enviar o recibo por SMS.`,
    TEXT_RECEIPT_SEND_SUCCESS: `Recibo enviado!`,
    TEXT_YOU_WHEN_READY: `Enviaremos uma mensagem quando seu pedido estiver pronto.`,
    THANK_YOU: `Obrigado!`,
    THEN_PRESS_BUTTON_1: `Em seguida, pressione o`,
    THEN_PRESS_BUTTON_2: `botão.`,
    TIP: `Gorjeta`,
    TIPPING: `Adicionando gorjeta...`,
    TIP_AMOUNT_TOO_HIGH: `O valor da gorjeta é muito alto.`,
    TIP_AMOUNT_TOO_LOW: `O valor da gorjeta é muito baixo.`,
    TIP_FAILED: `Desculpe! Não foi possível adicionar gorjeta. Por favor, tente novamente.`,
    TIP_CANNOT_BE_MODIFIED: `Desculpe! Você não pode modificar sua gorjeta depois de pagar o pedido.`,
    TIP_LABEL_PERCENT: `Toque para adicionar uma gorjeta de {{$1: percent}}% ({{$2: amount}})`,
    TIP_LABEL_FIXED: `Toque para adicionar uma gorjeta de {{$1: amount}}`,
    TIP_LABEL_CUSTOM: `Toque para adicionar uma gorjeta personalizada`,
    TIP_LABEL_NONE: `Toque para remover a gorjeta`,
    TO_GO: `Para viagem`,
    TOTAL: `Total`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `Os preços de alguns itens do seu pedido mudaram.`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `O subtotal foi alterado. O atual é`,
    TOTAL_CHANGED_LEADING_TEXT: `O total foi alterado. O atual é`,
    TOTAL_CHANGED_TRAILING_TEXT: `. Deseja prosseguir com o pedido?`,
    TOTAL_PAID: `Total pago`,
    TOTAL_REMAINING: `Restante a pagar`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `Tentar novamente`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `Não foi possível obter sua localização. Insira seu endereço.`,
    UNAVAILABLE_ITEM: `Desculpe, este item não está mais disponível.`,
    UNIT_GRAM: `{{$1: amount}}g`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} calorias`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} de proteína`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} de carboidratos`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} de gordura`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} de açúcar`,
    UP_TO_X: `até {{$1: number}}`,
    USE_COMP_CARD: `Usar cartão de cortesia`,
    USE_COUPON: `Usar cupom`,
    USE_EBT_CARD: `Cartão EBT`,
    USE_EBT_CASH_BENEFIT: `Benefício em dinheiro EBT`,
    USE_EBT_FOOD_STAMP: `Vale-alimentação EBT`,
    USE_GIFT_CARD: `Usar vale-presente`,
    USERNAME: `Nome de usuário`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `Email inválido`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} é obrigatório`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `Este campo é obrigatório`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `Use apenas letras e números`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `Use apenas letras, números, &, # e .`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `A senha deve conter pelo menos 1 dígito, 1 letra maiúscula, 1 letra minúscula e ter pelo menos 14 caracteres.`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `Nº de telefone inválido`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `O CEP deve conter apenas números`,
    VENDOR_UNAVAILABLE_MESSAGE: `No momento, essa unidade está fechada. Consulte o horário de funcionamento e volte mais tarde.`,
    VEHICLE_COLOR: `Cor do veículo`,
    VEHICLE_MAKE: `Marca do veículo`,
    VEHICLE_MODEL: `Modelo do veículo`,
    VERIFY_ACCOUNT: `Verificar conta`,
    VERIFY_ACCOUNT_CTA: `Verifique sua conta para começar a fazer pedidos.`,
    VIDEO_LOAD_FAILED: `Erro ao carregar o vídeo`,
    VIEW: `Ver`,
    WE_APOLOGIZE: `Pedimos desculpas pelo inconveniente.`,
    WEIGHING_INSTRUCTIONS: `Coloque seu item na balança`,
    WELCOME_BACK: `Bem-vindo de volta! Itens selecionados para você:`,
    WELCOME_BACK_WITH_NAME: `Bem-vindo de volta, {{$1: guest name}}! Itens selecionados para você:`,
    WELCOME_TO: `Bem-vindo ao {{$1: org name}}!`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `Escolher horário do pedido`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `Onde gostaria de retirar seu pedido?`,
    YES: `Sim`,
    YOU_PREVIOUSLY_ORDERED: `Você já pediu anteriormente`,
    YOUR_CURRENT_LOCATION: `Sua localização atual`,
    YOUR_NAME: `Seu nome`,
    YOUR_ORDER: `Seu pedido`,
    YOUR_SUBTOTAL: `Seu subtotal`,
    ZOOM_TOGGLE_ON: `Toque para ativar o zoom com dois dedos`,
    ZOOM_TOGGLE_OFF: `Toque para desativar o zoom com dois dedos`,
    ZOOM_INSTRUCTIONS: `O zoom com dois dedos está ativado. Use dois dedos para aproximar e afastar.`,
    STARBUCKS_COVER_1_BUTTON: `Sei o que quero`,
    STARBUCKS_COVER_2_BUTTON: `Explorar`,
    STARBUCKS_COVER_2_TITLE: `Experiências, degustações, aprendizado`,
    STARBUCKS_COVER_PROMO_A: `Buscador de café`,
    STARBUCKS_COVER_PROMO_B: `Starbucks Rewards`,
    STARBUCKS_EXPERIENCES_TITLE: `Experiências`,
    STARBUCKS_EXPERIENCES_SUBTITLE: `Mergulhe na arte, no teatro e na inovação do café ao reservar uma experiência exclusiva`,
    STARBUCKS_EXPERIENCES_RESERVE_NOW: `Reservar para hoje`,
    STARBUCKS_EXPERIENCES_RESERVE_LATER: `Reservar para mais tarde`,
    STARBUCKS_EXPERIENCES_BACK: `Voltar às experiências`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `Saiba mais`,
    STARBUCKS_WAYFINDER_CARD_MENU_BUTTON: `Ir ao menu`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `Onde estou?`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `Você está aqui`,
    STARBUCKS_WAYFINDER_BATHROOMS_LABEL: `Banheiros`,
    STARBUCKS_WAYFINDER_OPEN_SEATING_LABEL: `Assentos livres`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `Encontrar um local`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `Arraste com o dedo para explorar o espaço.`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `Toque em um local em destaque para saber mais sobre ele.`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_TITLE: `Aventura`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_SUBTITLE: `Quão aventureiro você gosta do seu café?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_TITLE: `Sabores preferidos`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_SUBTITLE: `Quando você pensa no seu café, quais sabores parecem mais deliciosos para você?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_TITLE: `Intensidade`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_SUBTITLE: `Quão intenso você gosta do seu café?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_TITLE: `Pedido de café preferido`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_SUBTITLE: `Como você costuma pedir seu café?`,
    STARBUCKS_COFFEE_FINDER_QUESTION_EDIT: `Toque para editar`,
    STARBUCKS_COFFEE_FINDER_QUESTION_CONFIRM: `Confirme sua seleção`,
    STARBUCKS_COFFEE_FINDER_QUESTION_RESTART: `Começar de novo`,
    STARBUCKS_COFFEE_FINDER_ANSWER_TITLE: `Parece que você vai gostar do`,
    STARBUCKS_COFFEE_FINDER_ANSWER_SUBTITLE: `Compre apenas os grãos, ou recomendamos a bebida abaixo com este grão:`,
    STARBUCKS_COFFEE_FINDER_ANSWER_GO_TO_MENU: `Ver o menu completo`,
    STARBUCKS_COFFEE_FINDER_ANSWER_RESTART: `Começar de novo`,
    STARBUCKS_VIEW_WAYFINDER: `Explorar`,
    STARBUCKS_VIEW_COFFEE_FINDER: `Refinar minhas opções`,
    STARBUCKS_VIEW_EXPERIENCES: `Ver experiências`,
    'cover.session.timeout': `Algo deu errado. Por favor, tente novamente.`,
    'cover.reduced-height.button': `Começar a pedir`,
    'cover.loyalty.title': `Bem-vindo`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `Entrar com programa de fidelidade`,
    'cover.loyalty.guest': `Continuar como convidado`,
    'guest-identifier.button.quit': `Sair`,
    'guest-identifier.button.skip': `Pular`,
    'guest-identifier.button.back': `Voltar`,
    'guest-identifier.button.next': `Continuar`,
    'guest-identifier.button.submit.cover': `Continuar`,
    'guest-identifier.button.submit.edit': `Continuar`,
    'guest-identifier.button.submit.checkout': `Continuar`,
    'guest-identifier.phone.tos.button-back': `Voltar`,
    'guest-identifier.phone.tos.title': `Termos de serviço`,
    'guest-identifier.phone.tos.link': `Termos de serviço para número de telefone`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `Entre com sua conta de fidelidade`,
    'guest-identifier.name.loyalty-button': `Entrar com fidelidade`,
    'guest-identifier.name.loyalty-separator': `ou`,
    'guest-identifier.name.loyalty-error-title': `Ops! Nome não encontrado`,
    'guest-identifier.name.loyalty-error-description': `Desculpe, não foi possível encontrar um nome associado a esta conta. Por favor, insira seu nome abaixo`,
    'inactivity-timer.button.continue': `Sim, preciso de mais tempo`,
    'inactivity-timer.button.exit': `Não, já terminei`,
    'item-card.add.with-quantity': `Adicionar ({{$1: quantity}})`,
    'image.scan.default.alt': `Escaneie seu código de barras ou QR code`,
    'loyalty.view_coupons': `Ver cupons`,
    'loyalty.add_coupons': `Adicionar cupons`,
    'loyalty.label.manual_redemption': `Código de resgate`,
    'loyalty.label.manual_redemption_instructions': `Insira seu código de resgate para usar sua recompensa`,
    'loyalty.label.welcome.new-user': `Olá, {{$1: user}}! Você já tem uma conta de fidelidade`,
    'loyalty.reward_label.payment_unapplied': `Aplicar pagamento ao cartão cadastrado`,
    'loyalty.reward_label.redeemable_unredeemed': `Resgatar com {{$1: points}} pontos`,
    'loyalty.reward_label.payment_at_checkout': `O pagamento pode ser aplicado ao finalizar a compra`,
    'loyalty.reward_group_label.payment': `Recompensas de pagamento`,
    'loyalty.rewards.payment-reward.name': `Pagar com saldo`,
    'loyalty.rewards.payment-reward.name-with-amount': `Pagar com saldo ({{$1: amount}})`,
    'loyalty.rewards.payment-reward.description': `Seu saldo atual`,
    'loyalty.rewards.card-on-file-payment.description': `O pagamento será cobrado no seu cartão cadastrado.`,
    'loyalty.redemption_auth.back_to_rewards': `Voltar às recompensas`,
    'loyalty.redemption_auth.subtitle': `Escaneie seu código de barras de resgate para usar sua recompensa`,
    'loyalty.redemption_auth.submit': `Resgatar recompensa`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `Insira seu nome`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `Por favor, aceite os termos e condições para continuar.`,
    'loyalty.checkout-signup.header': `Última chance de se cadastrar e ganhar recompensas neste pedido!`,
    'loyalty.checkout-signup.skip': `Pular e ir para o checkout`,
    'loyalty.checkout-signup.success.new-account.title': `Nova conta criada`,
    'loyalty.checkout-signup.success.new-account.description': `Obrigado por se juntar a nós, você vai ganhar recompensas neste pedido!`,
    'loyalty.checkout-signup.success.existing-account.title': `Conta já existente`,
    'loyalty.checkout-signup.success.existing-account.description': `Você já se cadastrou anteriormente com este número. Agora você está conectado.`,
    'loyalty.checkout-signup.error.title': `Erro ao criar conta`,
    'loyalty.checkout-signup.error.description': `Ocorreu um problema ao criar a conta`,
    'loyalty.checkout-signup.error.skip': `Pular e ir para o checkout`,
    'loyalty.checkout-signup.error.try-again': `Tentar novamente`,
    'menu.item.reset': `Redefinir item`,
    'menu.mod-group.quick-select': `Seleção rápida`,
    'menu.mod-group.quick-select-active': `Selecionado`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `Escaneie itens para começar a pedir`,
    'menu.page.scanner.scanned.title': `Itens do carrinho`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `Ver itens escaneados`,
    'order-history.button.add-to-order': `Adicionar itens disponíveis ({{$1: number}})`,
    'order-history.title': `Histórico de pedidos`,
    'order-history.subtitle': `Todos os seus pedidos anteriores aparecerão aqui. Interaja com os itens para visualizá-los ou adicioná-los ao seu pedido atual. Você pode adicionar todos os itens de um pedido com um único toque.`,
    'order-history.next-page': `Próximo`,
    'order-history.previous-page': `Anterior`,
    'order-history.screen.close': `Fechar`,
    'order-history.screen.error.title': `Ocorreu um erro`,
    'order-history.screen.error.subtitle': `Falha ao carregar o histórico de pedidos. Por favor, tente novamente mais tarde.`,
    'order-history.screen.error.button.back': `Voltar`,
    'order-history.screen.error.button.retry': `Tentar novamente`,
    'order-history.screen.no-orders': `Nenhum pedido anterior encontrado. Quando você fizer um pedido, volte aqui para vê-lo.`,
    'order-history.screen.order-has-quick-add-uneligible-items': `Alguns itens deste pedido não estão disponíveis para repetição rápida. Por favor, adicione os itens tocando neles individualmente.`,
    'order-history.section.button.view-all': `Ver mais dos meus pedidos`,
    'order-history.topbar.button.back': `Voltar`,
    'loyalty.unapplicable_rewards_warning_title': `Recompensas não aplicáveis`,
    'loyalty.unapplicable_rewards_warning_description': `Para resgatar a recompensa selecionada, adicione os itens correspondentes ao seu carrinho. A recompensa e o desconto serão aplicados no checkout.`,
    'loyalty.unapplicable_rewards_warning_confirm': `Aplicar`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `Entrada manual`,
    'loyalty.button.menu.authed': `Recompensas`,
    'loyalty.button.menu.unauthed': `Recompensas`,
    'loyalty.button.checkout.authed': `Recompensas`,
    'loyalty.button.checkout.unauthed': `Recompensas`,
    'loyalty.error.reward_failed_to_apply': `Não foi possível aplicar a recompensa. Por favor, tente novamente.`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `Pular e continuar ao menu`,
    'loyalty.login-options.button.skip.checkout': `Pular e continuar ao pagamento`,
    'loyalty.login-options.button.skip.dining-option-collection': `Pular e continuar o checkout`,
    'loyalty.login-options.title': `Escolha uma opção para entrar ou continue como convidado`,
    'loyalty.login-options.subtitle': `Você sempre pode entrar depois`,
    'loyalty.login-options.signup.link': `Não tem conta? Cadastre-se`,
    'loyalty.login-options.barcode.title': `Escanear código de barras`,
    'loyalty.login-options.barcode.subtitle': `Escaneie seu código de barras para entrar`,
    'loyalty.login-options.email-phone-number.title': `E-mail e número de telefone`,
    'loyalty.login-options.email-phone-number.subtitle': `Insira seu e-mail e número de telefone para entrar`,
    'loyalty.login-options.email-password.title': `E-mail e senha`,
    'loyalty.login-options.email-password.subtitle': `Insira seu e-mail e senha para entrar`,
    'loyalty.login-options.username-password.title': `Nome de usuário e senha`,
    'loyalty.login-options.username-password.subtitle': `Insira seu nome de usuário e senha para entrar`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `Número de telefone`,
    'loyalty.login-options.phone-number.subtitle': `Insira seu número de telefone para entrar`,
    'loyalty.login-options.card-number.title': `Número do cartão`,
    'loyalty.login-options.card-number.subtitle': `Insira seu número de cartão para entrar`,
    'loyalty.login-options.email.title': `E-mail`,
    'loyalty.login-options.email.subtitle': `Insira seu e-mail para entrar`,
    'loyalty.login-options.or': `OU`,
    'loyalty.login-options.popup.close': `Fechar`,
    'loyalty.error.or': `OU`,
    'loyalty.login-error.saved-form': `As informações que você enviou:`,
    'loyalty.login-error.try-again.button': `Tentar novamente`,
    'loyalty.otp.enter-code.title': `Insira o código que enviamos`,
    'loyalty.otp.sent-to.email': `Enviamos um código por e-mail para {{$1: masked email}}`,
    'loyalty.otp.sent-to.sms': `Enviamos um código por mensagem de texto para {{$1: masked phone number}}`,
    'loyalty.otp.verify': `Verificar`,
    'loyalty.otp.resend': `Reenviar código`,
    'loyalty.otp.code.error.invalid': `Esse código está incorreto. Por favor, tente novamente.`,
    'loyalty.otp.send-error.message': `Não conseguimos encontrar uma única conta com essas informações. Por favor, verifique e tente novamente.`,
    'loyalty.login.fallback.phone-number.button': `Usar um número de telefone`,
    'loyalty.login.fallback.barcode.button': `Escanear código de barras ou QR code`,
    'loyalty.login.fallback.card-number.button': `Usar um número de cartão`,
    'loyalty.login.fallback.email.button': `Usar um e-mail`,
    'loyalty.login.fallback.email-phone-number.button': `Usar e-mail e número de telefone`,
    'loyalty.login.fallback.email-password.button': `Usar e-mail e senha`,
    'loyalty.login.fallback.username-password.button': `Usar nome de usuário e senha`,
    'loyalty.login.auth-method.phone-number.title': `Número de telefone`,
    'loyalty.login.auth-method.barcode.title': `Escanear código de barras ou QR code`,
    'loyalty.login.auth-method.card-number.title': `Número do cartão`,
    'loyalty.login.auth-method.email.title': `E-mail`,
    'loyalty.login.auth-method.email-phone-number.title': `E-mail e número de telefone`,
    'loyalty.login.auth-method.email-password.title': `E-mail e senha`,
    'loyalty.login.auth-method.username-password.title': `Nome de usuário e senha`,
    'vitrine.error.order_validation_failed': `Falha ao validar o pedido. Por favor, tente novamente.`,
    'vitrine.error.handshake_failed': `Não foi possível conectar ao quiosque. Por favor, contate um membro da equipe.`,
    'vitrine.error.request_timeout': `Não foi possível concluir a solicitação. Por favor, tente novamente.`,
    'vitrine.error.request_aborted': `Não foi possível concluir a solicitação. Por favor, tente novamente.`,
    'vitrine.error.analytics_send_error': `Não foi possível enviar os dados analíticos. Por favor, tente novamente.`,
    'vitrine.error.garcon_incompatible_build': `Não foi possível conectar ao quiosque. Por favor, contate um membro da equipe para obter ajuda.`,
    'vitrine.error.loyalty-login-no-matching-user-title': `Sua conta não foi encontrada`,
    'vitrine.error.loyalty-login-no-matching-user-message': `Não encontramos um usuário com as informações fornecidas.`,
    'vitrine.error.loyalty_not_enough_points': `Sua conta não tem pontos suficientes para resgatar as recompensas selecionadas.`,
    'vitrine.error.order_total_above_max': `O total do pedido excedeu o máximo permitido. Por favor, contate um membro da equipe.`,
    'vitrine.error.empty_menu': `O menu que você selecionou está vazio no momento. Por favor, tente outra opção de refeição.`,
    'maitred.error.integration_bad_config': `Parece haver um problema com a configuração do quiosque. Por favor, contate um membro da equipe.`,
    'checkout.done.expo_receipt.error': `Não foi possível imprimir o recibo. Por favor, tente novamente.`,
    'checkout.done.expo_receipt.success': `Recibo enviado! Por favor, peça ajuda a um membro da equipe.`,
    'checkout.done.print-receipt.out-of-paper': `A impressora está sem papel. Por favor, procure um membro da equipe para obter seu recibo.`,
    'refunder.viewing-results.button.cancel': `Cancelar`,
    'refunder.viewing-results.button.refund-all': `Reembolsar tudo`,
    'refunder.viewing-results.button.view-transaction': `Ver transações`,
    'refunder.viewing-results.button.done': `Concluído`,
    'refunder.viewing-results.button.back': `Voltar`,
    'refunder.viewing-results.button.search': `Buscar pedido`,
    'refunder.viewing-results.refund-order.error-print-receipt': `O pedido foi reembolsado com sucesso, mas não conseguimos imprimir o recibo. Por favor, tente imprimir novamente.`,
    'refunder.viewing-results.refund-order.success': `Pedido reembolsado com sucesso.`,
    'refunder.viewing-results.refund-order.error': `Falha ao reembolsar pedido. Por favor, tente novamente.`,
    'refunder.viewing-results.order.refunded': `Pedido reembolsado`,
    'refunder.viewing-results.order.total': `Total do pedido`,
    'refunder.search-form.button.back': `Voltar`,
    'refunder.search-form.button.search': `Buscar`,
    'refunder.viewing-order.title': `Todas as transações do pedido #{{$1: order number}}`,
    'refunder.viewing-order.subtitle': `Por favor, selecione a transação que deseja reembolsar.`,
    'refunder.viewing-order.button.cancel': `Cancelar`,
    'refunder.viewing-order.button.refund': `Reembolsar`,
    'refunder.viewing-order.button.refund-partial': `Reembolso parcial`,
    'refunder.viewing-order.button.retry': `Tentar novamente`,
    'refunder.viewing-order.button.done': `Concluído`,
    'refunder.viewing-order.button.back': `Voltar`,
    'refunder.viewing-order.refund-transaction.error': `Não foi possível reembolsar a transação. Por favor, tente novamente.`,
    'refunder.viewing-order.refund-transaction.success': `Transação reembolsada com sucesso.`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `A transação foi reembolsada com sucesso, mas não conseguimos imprimir o recibo. Por favor, tente imprimir novamente.`,
    'refunder.viewing-order.transaction.total': `Total`,
    'refunder.viewing-order.transaction.refunded': `Reembolsado`,
    'refunder.viewing-order.error.title': `Erro`,
    'refunder.viewing-order.error.message': `Falha ao carregar o pedido. Por favor, tente novamente.`,
    'refunder.viewing-order.error.button.retry': `Tentar novamente`,
    'refunder.viewing-order.error.button.back': `Voltar`,
    'refunder.partial-transaction-refund.error.amount-too-high': `O valor é muito alto.`,
    'refunder.partial-transaction-refund.error.amount-too-low': `O valor é muito baixo.`,
    'refunder.partial-transaction-refund.error.amount-invalid': `O valor é inválido.`,
    'refunder.partial-transaction-refund.error.amount-required': `O valor é obrigatório.`,
    'refunder.partial-transaction-refund.error': `Houve um problema ao processar o reembolso. Por favor, tente novamente.`,
    'refunder.partial-transaction-refund.button.submit': `Enviar reembolso parcial`,
    'refunder.partial-transaction-refund.button.back': `Voltar`,
    'refunder.partial-transaction-refund.title': `Reembolso parcial de transação`,
    'refunder.partial-transaction-refund.hint': `Por favor, insira o valor que deseja reembolsar. O valor máximo é {{$1: amount}}`,
    'refunder.partial-transaction-refund.label': `Valor`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.group-ordering.actions.change-recipient': `Editar destinatário`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `Atribuir item a`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `Cancelar`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `Adicionar novo`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `Reatribuir`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `Para quem é este item?`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `Atribuir a este convidado`,
    'checkout.cart.starbucks-stars': `Item de {{$1: amount}} \u2605`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'menu.nav.starbucks.menu': `Menu principal`,
    'menu.nav.starbucks.experiences': `Experiências`,
    'menu.nav.starbucks.wayfinder': `Explorar o local`,
    'menu.secret-menu.access-code.title': `Inserir código de acesso`,
    'menu.secret-menu.access-code.button.back': `Voltar`,
    'menu.secret-menu.access-code.button.submit': `Enviar`,
    'menu.secret-menu.access-code.error': `Código de acesso inválido`,
    'menu.secret-menu.access-code.success': `Código de acesso aceito`,
    'menu.toast.added-to-cart': `Adicionado ao carrinho`,
    'menu.toast.combo-savings': `Economia no combo!`,
    'menu.toast.discount-applied': `Desconto aplicado!`,
    'menu.exit-verification.title': `Verificação do gerente necessária`,
    'menu.exit-verification.description': `É necessário um código de acesso de funcionário para sair. Por favor, solicite ajuda a um membro da equipe.`,
    'menu-item.starbucks-stars': `{{$1: amount}} \u2605`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `Por favor, coloque seu item na balança.`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `Pesa`,
    'menu-item.scale.price-per-unit': `{{$1: price}} por {{$2: unit}}`,
    'menu-item.scale.price': `Preço`,
    'menu-item.scale.instructions': `Use a balança para pesar seu item. Para reiniciar, pressione o botão indicado na balança.`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `Pesando...`,
    'menu-item.scale.error-reading-weight': `Erro ao ler o peso. Por favor, tente novamente.`,
    'menu-item.scale.error-no-weight': `Por favor, pese seu item se quiser adicioná-lo ao pedido.`,
    'menu-item.scale.no-scale': `Nenhuma balança detectada. Por favor, contate um membro da equipe.`,
    'also-consider.title': `Você também pode gostar...`,
    'also-consider.back-to-item': `Voltar ao item`,
    'also-consider.add-to-order': `Adicionar ao pedido`,
    'also-consider.skip-add-on': `Pular complemento`,
    'menu-item.assorted.title': `Monte seu sortimento`,
    'menu-item.assorted.count': `{{$1: count}} de {{$2: total}} selecionados`,
    'menu-item.row-size-mod.option.none': `Nenhum`,
    'menu-item.high-sugar-warning.description': `Aviso: Este ícone indica que o teor de açúcares adicionados deste item é igual ou superior ao limite diário total recomendado de açúcares adicionados para uma dieta de 2.000 calorias (50 g). Consumir grandes quantidades de açúcares adicionados ao longo do tempo pode aumentar o risco de diabetes tipo 2, ganho de peso e cáries.`,
    'menu-item.high-sodium-warning.description': `Aviso: Este ícone indica que o teor de sódio (sal) deste item é superior ao limite diário total recomendado (2.300 mg). O alto consumo de sódio pode aumentar a pressão arterial e o risco de doenças cardíacas e derrames.`,
    'menu-item.group-ordering.items-for': `Pedido em grupo - Itens para:`,
    'menu-item.group-ordering.prompt.title': `Pedir em grupo?`,
    'menu-item.group-ordering.prompt.description': `A opção de pedido em grupo perguntará a qual membro do seu grupo cada item pertence. Toque em "Sim" para ativar o pedido em grupo. Toque em "Não" se quiser continuar com esta opção.`,
    'menu-item.group-ordering.prompt.button.accept': `Sim, pedido em grupo`,
    'menu-item.group-ordering.prompt.button.decline': `Não, obrigado`,
    'menu-item.group-ordering.add-recipient': `Adicionar novo`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `Adicionar novo destinatário`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `Insira o nome do destinatário`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `Atribuir ao convidado`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `Cancelar`,
    'menu-item.group-ordering.recipient-picker.title': `Para quem é?`,
    'menu-item.group-ordering.recipient-picker.add-new': `Adicionar novo`,
    'menu-item.nested-mod-groups.edit': `Editar`,
    'menu-item.nested-mod-groups.popup.done': `Concluído`,
    'menu-item.nested-mod-groups.popup.cancel': `Cancelar`,
    'menu-item.nested-mod-groups.popup.back': `Voltar`,
    'menu-item.nested-mod-groups.popup.next': `Próximo`,
    'checkout.cart.remove-item-verification.title': `Verificação do gerente necessária`,
    'checkout.cart.remove-item-verification.description': `É necessário um código de acesso de funcionário para remover este item do carrinho. Por favor, solicite ajuda a um membro da equipe.`,
    'checkout.cart.confirm-remove-item.title': `Remover item?`,
    'checkout.cart.confirm-remove-item.description': `Tem certeza de que deseja remover {{$1: item name}} do seu carrinho?`,
    'checkout.cart.confirm-remove-item.cancel': `Cancelar`,
    'checkout.cart.confirm-remove-item.confirm': `Remover`,
    'checkout.cart.pre-checkout-recommendations.title': `Complete seu pedido`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `Continuar`,
    'checkout.cart.pre-checkout-recommendations.back-button': `Voltar`,
    'checkout.cart.item-86d.title.items': `Alguns itens não estão mais disponíveis`,
    'checkout.cart.item-86d.title.mods': `Algumas modificações não estão mais disponíveis`,
    'checkout.cart.item-86d.title.mixed': `Alguns itens e modificações não estão mais disponíveis`,
    'checkout.cart.item-86d.description.items': `Os seguintes itens foram removidos do seu carrinho:`,
    'checkout.cart.item-86d.description.mods': `As seguintes modificações foram removidas dos seus itens:`,
    'checkout.cart.item-86d.description.mixed': `Os itens a seguir não estão mais disponíveis e foram removidos:`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}} (em {{$2: item name}})`,
    'checkout.cart.item-86d.edit-item-button': `Editar`,
    'checkout.payment-options.tip.invalid-tip-amount': `Desculpe, você não pode aplicar uma gorjeta maior que o total do pedido. Por favor, insira um valor de gorjeta menor que o subtotal do pedido menos os descontos.`,
    'checkout.payment-options.name.title': `Olá, {{$1: name}}`,
    'checkout.payment-options.gift-cards.prompt.title': `Selecione um método de vale-presente`,
    'checkout.payment-options.gift-cards.prompt.default-option': `Vale-presente`,
    'checkout.payment-options.pay-with-cash-machine.label': `Toque para pagar na máquina de dinheiro`,
    'checkout.payment-options.pay-with-cash-machine.button': `Dinheiro`,
    'checkout.payment-options.donation.or': `OU`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `Informações da taxa de serviço`,
    'checkout.payment-options.credit-card.button.zero-balance': `Fazer pedido`,
    'checkout.payment-options.inline-loyalty.view-all': `Ver todas as recompensas`,
    'checkout.payment-options.inline-loyalty.apply': `Aplicar recompensas`,
    'checkout.payment-options.inline-loyalty.greeting': `Olá, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.star-balance': `Saldo de estrelas: {{$1: stars}}\u2605`,
    'checkout.payment-options.inline-loyalty.celebration.title': `Feliz aniversário!`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `Feliz aniversário, {{$1: name}}!`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `Aproveite seu presente!`,
    'checkout.payment-options.inline-loyalty.error.title': `Não foi possível aplicar as recompensas`,
    'checkout.payment-options.inline-loyalty.error.message': `Houve um erro ao aplicar suas recompensas. Por favor, tente novamente.`,
    'loyalty.starbucks.header.redeemable-stars': `Estrelas resgatáveis`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}\u2605 vencem em {{$2: date}}`,
    'loyalty.starbucks.header.stars-no-expiry': `Suas estrelas não vão vencer`,
    'loyalty.starbucks.progress.next-status-by-date': `Ganhe {{$1: stars}}\u2605 até {{$2: date}} para alcançar o nível {{$3: level}}`,
    'loyalty.starbucks.progress.next-status': `Ganhe {{$1: stars}}\u2605 para alcançar o nível {{$2: level}}`,
    'loyalty.starbucks.progress.maintain-status-by-date': `Ganhe {{$1: stars}}\u2605 até {{$2: date}} para estender seu nível {{$3: level}} por mais um ano`,
    'loyalty.starbucks.progress.maintain-status': `Ganhe {{$1: stars}}\u2605 para estender seu nível {{$2: level}} por mais um ano`,
    'loyalty.starbucks.progress.extended': `Estendido por mais um ano`,
    'loyalty.starbucks.progress.annual-earned': `Ganhas este ano`,
    'loyalty.starbucks.progress.status-target': `Nível {{$1: level}}`,
    'loyalty.starbucks.progress.to-extend': `para estender`,
    'loyalty.starbucks.birthday.title': `Feliz aniversário, {{$1: name}}!`,
    'loyalty.starbucks.birthday.title-no-name': `Feliz aniversário!`,
    'loyalty.starbucks.birthday.redeem': `Resgate seu cupom de aniversário!`,
    'loyalty.starbucks.birthday.description': `Aproveite sua bebida ou guloseima favorita, por nossa conta. Resgate no checkout ou avise seu barista ao pedir.`,
    'loyalty.starbucks.birthday.valid-until': `Válido até {{$1: date}}`,
    'loyalty.starbucks.member-since': `Membro desde {{$1: year}}`,
    'loyalty.starbucks.member-since.subtitle': `Obrigado por ser um membro fiel do Starbucks Rewards.`,
    'checkout.paying.starbucks.title': `Por favor, escaneie agora o QR code no seu app do Starbucks`,
    'checkout.paying.starbucks.subtitle': `Certifique-se de ter o recurso Scan to Pay pronto no seu app do Starbucks para concluir seu pedido.`,
    'checkout.paying.starbucks.cancel-button': `Cancelar`,
    'checkout.paying.error.loyalty-payment': `Desculpe, não foi possível processar seu pagamento. Por favor, tente novamente.`,
    'checkout.paying.error.pos.print': `Continuar e imprimir recibo`,
    'checkout.paying.error.table-tracker.print': `Continuar e imprimir recibo`,
    'checkout.paying.error.table-tracker.title': `Ops! Não conseguimos obter seu localizador.`,
    'checkout.paying.error.table-tracker.instructions': `Seu pedido foi processado, mas houve um erro ao dispensar o localizador de mesa para rastrear seu pedido. Prossiga para a próxima etapa para receber seu recibo.`,
    'checkout.paying.error.title': `Ops!`,
    'checkout.paying.sending-table-tracker-request.title': `Dispensando localizador`,
    'checkout.paying.sending-table-tracker-request.subtitle': `Por favor, aguarde enquanto dispensamos seu localizador de mesa.`,
    'checkout.paying.cash-machine.pinging.title': `Verificando a máquina de dinheiro`,
    'checkout.paying.cash-machine.pinging.subtitle': `Por favor, aguarde enquanto verificamos se a máquina de dinheiro está disponível.`,
    'checkout.paying.cash-machine.awaiting.title': `Máquina de dinheiro em uso`,
    'checkout.paying.cash-machine.awaiting.subtitle': `Por favor, aguarde até que a máquina de dinheiro esteja disponível.`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `Cancelar`,
    'checkout.paying.cash-machine.receiving.title': `Máquina de dinheiro pronta`,
    'checkout.paying.cash-machine.receiving.subtitle': `Por favor, insira seu pagamento na máquina de dinheiro.`,
    'checkout.paying.cash-machine.receiving.cancel-button': `Cancelar`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `Cancelar e reembolsar o pagamento`,
    'checkout.paying.cash-machine.receiving.partial-button': `Pagar o restante de outra forma`,
    'checkout.paying.cash-machine.receiving.amount': `{{$1: amount}} restante`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `Por favor, retire todas as cédulas e moedas da máquina de dinheiro.`,
    'checkout.paying.cash-machine.cancelling.title': `Cancelando o pagamento na máquina de dinheiro`,
    'checkout.paying.cash-machine.cancelling.subtitle': `Por favor, retire todas as cédulas e moedas da máquina de dinheiro.`,
    'checkout.paying.cash-machine.cancelling.error.title': `Erro ao cancelar o pagamento na máquina de dinheiro`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `Não foi possível cancelar seu pagamento. Por favor, peça ajuda a um membro da equipe.`,
    'checkout.paying.cash-machine.cancelling.error.print': `Continuar e imprimir recibo`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `Troco insuficiente`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `A máquina de dinheiro não conseguiu dar troco para seu pagamento, então reembolsamos seu pagamento.`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `Tentar novamente`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `Voltar`,
    'checkout.paying.cash-machine.error.message': `A máquina de dinheiro não conseguiu processar seu pagamento. Por favor, tente novamente.`,
    'checkout.done.details.guest-name': `Nome`,
    'checkout.done.details.table-number': `Número da mesa`,
    'checkout.done.details.tracker-number': `Número do rastreador`,
    'checkout.done.details.order-number': `Número do pedido`,
    'checkout.done.error.table-tracker.instructions': `Houve um erro ao obter seu localizador. Seu pedido foi processado com sucesso. Por favor, peça ajuda a um funcionário.`,
    'checkout.done.qr-code.error': `Desculpe, não foi possível gerar um QR code para seu recibo.`,
    'printer-receipt.stored-value-remaining-balance': `Saldo restante de {{$1: label}}`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `A opção de refeição que você selecionou não está mais disponível. Seu pedido foi atualizado para usar "{{$1: dining option name}}".`,
    'order-reconciler.error.items-unavailable': `Alguns itens do seu pedido não estão mais disponíveis. Seu pedido foi atualizado para remover os itens indisponíveis. Os seguintes itens foram removidos: {{$1: item names}}`,
    'page-nav.order-history-item.title': `Meus pedidos`,
    'page-nav.order-history-item.cta': `Ver meus pedidos`,
    'print.error.phone-number-label': `Número de telefone`,
    'print.error.guest-name-label': `Nome`,
    'print.error.table-number-label': `Número da mesa`,
    'print.error.tracker-number-label': `Número do localizador`,
    'print.error.order-number-label': `Número do pedido`,
    'debug.untranslated-locale': ``,
};
//# sourceMappingURL=strings.pt-br.js.map